export default __webpack_public_path__ + "static/media/icon_culinary.93651728.svg";